import React, { useEffect } from 'react';
import { selectedDepartmentAtom } from '../shared/selected.department';
import { useAtom } from 'jotai';
import { selectedTurnItem } from '../shared/selected.turn.items';
import { selectedTurnBase } from '../shared/selected.turn.base';

const useHandleInitialStepLogic = (data) => {
  const [turnBase, setTurnBase] = useAtom(selectedTurnBase);

  const turn_configs = JSON.parse(
    localStorage.getItem('nobat_prefrence')
  );
  const main_turn_config = Number(
    turn_configs?.filter(
      (fl) => fl.Key === 'webAppnoeEntekhabeNobatPatient'
    )[0]?.Value
  );



  useEffect(() => {
    if (main_turn_config === 1) {
      setTurnBase('service');
      return;
    }
    if (main_turn_config === 2) {
      setTurnBase('speciality');
      return;
    }
  }, [main_turn_config]);

  const [selectedDepartment, setSelectedDepartment] =
    useAtom(selectedDepartmentAtom);
  const [, setSelectedTurnItem] = useAtom(selectedTurnItem);

  useEffect(() => {
    if (data?.departments?.length === 1) {
      setSelectedDepartment(data?.departments[0]);
    }
  }, [data]);

  // console.log('selectedDepartment, turnBase, data===>', {
  //   selectedDepartment,
  //   turnBase,
  //   data,
  // });

  useEffect(() => {
    if (selectedDepartment) {
      if (
        turnBase === 'service' &&
        data?.turnBaseData?.serviceBased?.length === 1
      ) {
        setSelectedTurnItem(
          data?.turnBaseData?.serviceBased[0]
        );
        return;
      }
      if (
        turnBase === 'speciality' &&
        data?.turnBaseData?.specialityBased?.length === 1
      ) {
        setSelectedTurnItem(
          data?.turnBaseData?.specialityBased[0]
        );
        return;
      }
    }
  }, [selectedDepartment, turnBase, data]);
};

export default useHandleInitialStepLogic;
